export const DIGIKEY_PROXY_SETTING_KEY = "DIGIKEY_PROXY";

export const DIGIKEY_PROXY_OPTIONS = [
  { value: "oxylabs", label: "Oxylabs Web Scraper API" },
  { value: "residential", label: "Oxylabs Residential" },
  { value: "none", label: "No proxy" },
];

export const digikeyProxyLabel = (value) => {
  const match = DIGIKEY_PROXY_OPTIONS.find((option) => option.value === value);
  return match ? match.label : value || "";
};

export const SETTING_VALUE_TYPES = [
  { value: "STRING", label: "String" },
  { value: "NUMBER", label: "Number" },
  { value: "INTEGER", label: "Integer" },
  { value: "PRICE", label: "Price" },
  { value: "PERCENTAGE", label: "Percentage" },
  { value: "BOOLEAN", label: "Boolean" },
  { value: "DATE", label: "Date" },
  { value: "DATETIME", label: "Date and Time" },
  { value: "EMAIL", label: "Email" },
  { value: "URL", label: "URL" },
];

export const normalizeSettingType = (type) => {
  const value = String(type || "STRING").toUpperCase();
  if (value === "TEXT") {
    return "STRING";
  }
  return SETTING_VALUE_TYPES.some((item) => item.value === value)
    ? value
    : "STRING";
};

export const formatSettingValueDisplay = (row) => {
  const type = normalizeSettingType(row?.setting_type);
  const value = row?.setting_value == null ? "" : String(row.setting_value);
  if (row?.setting_key === DIGIKEY_PROXY_SETTING_KEY) {
    return digikeyProxyLabel(value);
  }
  if (type === "PRICE") {
    return `$${value}`;
  }
  if (type === "PERCENTAGE") {
    return `${value}%`;
  }
  return value;
};

export const getSettingValueInputType = (type) => {
  switch (normalizeSettingType(type)) {
    case "NUMBER":
    case "INTEGER":
    case "PRICE":
    case "PERCENTAGE":
      return "number";
    case "DATE":
      return "date";
    case "DATETIME":
      return "datetime-local";
    case "EMAIL":
      return "email";
    case "URL":
      return "url";
    default:
      return "text";
  }
};

export const validateSettingValueForType = (type, rawValue) => {
  const settingType = normalizeSettingType(type);
  const value = String(rawValue || "").trim();
  if (!value) {
    return "Setting value is required.";
  }
  if (value.length > 200) {
    return "Setting value cannot exceed 200 characters.";
  }

  switch (settingType) {
    case "NUMBER":
    case "PRICE":
    case "PERCENTAGE":
      if (!Number.isFinite(Number(value))) {
        return "Setting value must be a valid number for this type.";
      }
      if (settingType === "PRICE" && Number(value) < 0) {
        return "Price must be zero or greater.";
      }
      if (settingType === "PERCENTAGE" && (Number(value) < 0 || Number(value) > 100)) {
        return "Percentage must be between 0 and 100.";
      }
      return null;
    case "INTEGER":
      if (!/^-?\d+$/.test(value)) {
        return "Setting value must be a whole number.";
      }
      return null;
    case "BOOLEAN":
      if (!["true", "false", "1", "0", "yes", "no"].includes(value.toLowerCase())) {
        return "Boolean value must be true, false, 1, 0, yes, or no.";
      }
      return null;
    case "DATE":
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return "Date must be in YYYY-MM-DD format.";
      }
      return null;
    case "EMAIL": {
      const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      return emailOk ? null : "Setting value must be a valid email address.";
    }
    case "URL":
      try {
        new URL(value);
        return null;
      } catch (e) {
        return "Setting value must be a valid URL.";
      }
    default:
      return null;
  }
};
